import { useCustomMetadataModal } from "hooks/useCustomMetadataModal";
import { useModalOperatorsAndValues } from "hooks/CustomMetadata/useModalOperatorsAndValues";
import { CustomMetadata } from "types";
import { DateTime, DateTimeRange } from "views/components/DatePicker";
import { DateTimeIcon } from "assets/icons/CustomMetadataIcons";
import BaseQueryModal from "./BaseQueryModal";
import {
  formatDateForAPI,
  formatDateRangeForAPI,
} from "helpers/utility/customMetadataHelpers";
import styles from "./style.module.scss";
import {useDateTimeQueryModal} from "hooks/UseQueryModal/useDateTimeQueryModal";

interface DateTimeModalProps {
  field: CustomMetadata;
  editQueryId?: string;
}

export default function DateTimeModal({
  editQueryId,
  field,
}: DateTimeModalProps) {
  const { modalRef, handleSubmission, fieldName } = useCustomMetadataModal({
    field,
    editQueryId,
  });

  const { operator, setOperator, operatorOptions, value, setValue, mode } =
    useModalOperatorsAndValues({
      type: "datetime",
      field,
      editQueryId,
      options: [],
    });

  const hasValidDate =
    !!value.single || (value.range && value.range.length === 2);

  const { isSubmitDisabled } = useDateTimeQueryModal({
    operator,
    isValid: hasValidDate,
  });

  const handleSubmit = () => {
    if (isSubmitDisabled || !operator) return;
    let submitValue: string | string[];
    if (value.range && value.range.length === 2) {
      submitValue = formatDateRangeForAPI(value.range)!;
    } else if (value.single) {
      submitValue = formatDateForAPI(value.single)!;
    } else return;
    handleSubmission(operator, submitValue);
  };

  const operators = {
    options: operatorOptions,
    selected: operator,
    onSelect: setOperator,
  };

  const dateTimeComponent = {
    Single: (
      <DateTime
        value={value.single}
        onChange={(v) => setValue({ ...value, single: v })}
      />
    ),
    Range: (
      <DateTimeRange
        value={value.range}
        onChange={(v) => setValue({ ...value, range: v })}
      />
    ),
  };

  return (
    <BaseQueryModal
      title={fieldName}
      keepOpenOnLoading
      modalRef={modalRef}
      icon={<DateTimeIcon />}
      isSubmitDisabled={isSubmitDisabled}
      onSubmit={handleSubmit}
      operators={operators}
    >
      <div className={styles.dateTimeContainer}>{dateTimeComponent[mode]}</div>
    </BaseQueryModal>
  );
}
